import React from 'react';
import classNames from 'classnames';

const MaintenancePanelTilt = (props) => {
  return (
    <div
      id={props.id}
      role="menuitem"
      aria-disabled={props.disabled}
      className={classNames({
        maintenanceBarTile: true,
        maintenanceBarTile_Disabled: props.disabled
      })}
      onClick={() => {
        !props.disabled && props.handleMBarSelection(props.selectionId);
      }}
      data-tip={props.hoverMessage ? props.hoverMessage : props.title}
    >
      {props.customTitle ? props.customTitle : props.title}
    </div>
  );
};

export default MaintenancePanelTilt;
